import { createFileRoute } from "@tanstack/react-router";
import { CertificationModulesListPage } from "../../../components/system/CertificationModulesListPage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/certifications/")({
  beforeLoad: requireSuperAdmin(),
  component: CertificationModulesListPage,
});
